'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _components2 = require('../../components');

var _components = {
  _$PostActions: {
    displayName: 'PostActions'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostActions.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostActions.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostActions = (function (_Component) {
  _inherits(PostActions, _Component);

  function PostActions() {
    _classCallCheck(this, _PostActions);

    _Component.apply(this, arguments);
  }

  PostActions.prototype.getNextPost = function getNextPost() {
    var _props = this.props;
    var posts = _props.posts;
    var post = _props.post;

    var index = posts.findIndex(function (item) {
      return item.id === post[0].id;
    });
    return posts[index + 1] ? posts[index + 1] : posts[0];
  };

  PostActions.prototype.sharePostFacebook = function sharePostFacebook() {
    window.FB.ui({
      method: 'share',
      href: window.location.href
    });
  };

  PostActions.prototype.sharePostLinkedin = function sharePostLinkedin() {
    var shareUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href;
    window.open(shareUrl, '_blank', 'location=yes, height=570, width=520, scrollbars=yes, status=yes');
  };

  PostActions.prototype.renderSocialItems = function renderSocialItems() {
    // todo add details var after fix
    var detailsLoading = this.props.detailsLoading;

    if (detailsLoading) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'dark', size: '25' });
    }

    return _react2['default'].createElement('div', { className: 'social-items social-items--share animated-300 fadeInUp' });
  };

  PostActions.prototype.renderActionButton = function renderActionButton() {
    var _props2 = this.props;
    var post = _props2.post;
    var postsLoading = _props2.postsLoading;

    var next = this.getNextPost();

    if (postsLoading) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'dark', size: '25' });
    }

    if (post[0].action_link) {
      return _react2['default'].createElement(
        _reactRouter.Link,
        { className: 'post-actions__action-btn btn btn--tertiary', to: post[0].action_link, key: post[0].id },
        post[0].action_text ? post[0].action_text : 'Article action'
      );
    }

    return _react2['default'].createElement(
      _reactRouter.Link,
      { className: 'post-actions__action-btn btn btn--tertiary', to: '/' + next.categories.names[0].name + '/' + next.slug, key: next.id },
      'Read next'
    );
  };

  PostActions.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      { className: 'post-actions' },
      this.renderActionButton(),
      _react2['default'].createElement(
        'div',
        { className: 'post-actions__share' },
        this.renderSocialItems()
      )
    );
  };

  _createClass(PostActions, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.array,
      postLoading: _react.PropTypes.bool.isRequired,
      posts: _react.PropTypes.array,
      postsLoading: _react.PropTypes.bool.isRequired,
      details: _react.PropTypes.object,
      detailsLoading: _react.PropTypes.bool.isRequired
    },
    enumerable: true
  }]);

  var _PostActions = PostActions;
  PostActions = _wrapComponent('_$PostActions')(PostActions) || PostActions;
  PostActions = _reactRedux.connect(function (state) {
    return {
      post: state.post.data,
      postLoading: state.post.loading,
      posts: state.posts.data,
      postsLoading: state.posts.loading,
      details: state.details.data,
      detailsLoading: state.details.loading
    };
  })(PostActions) || PostActions;
  return PostActions;
})(_react.Component);

exports['default'] = PostActions;
module.exports = exports['default'];
/* <a className="social-items__item social-items__item--facebook" onClick={this.sharePostFacebook}>
 <div className="social-items__item-icon">
   <svg className="icon icon--facebook" viewBox="0 0 11 22">
      <use xlinkHref="#icon-facebook"></use>
   </svg>
 </div>
 <span className="social-items__item-value">{details.facebook}</span>
</a> */ /* <a className="social-items__item social-items__item--linkedin social-items__item--last" onClick={this.sharePostLinkedin}>
         <div className="social-items__item-icon">
           <svg className="icon icon--linkedin" viewBox="0 0 22 22">
              <use xlinkHref="#icon-linkedin"></use>
           </svg>
         </div>
         <span className="social-items__item-value">{details.linkedin}</span>
        </a> */


//////////////////
// WEBPACK FOOTER
// ./src/components/PostSingle/PostActions.js
// module id = 312
// module chunks = 0